<script lang="ts" setup></script>

<template>
  <div :class="$style.container" @click="$emit('click')" />
</template>

<style module>
.container {
  display: flex;
  width: 4rem;
  height: 2rem;
  background-color: var(--color-white);
  mask-image: url("./assets/align_logo_light.svg");
  background-position: center center;
  background-size: cover;
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  cursor: pointer;
}
</style>
